import React, { Fragment, useState, useEffect} from "react"
import {useLocation, useHistory} from "react-router-dom"

// Material-UI Core
import {makeStyles} from "@material-ui/core/styles"

// Custom Component
import {Alert} from '../Alert/Alert'
import SignOut from './SignOut'

// Custom Style
import signInStyle from "../../styles/jss/components/signIn/signInStyle"

// Fetch Data
import {oidcSignIn, getUserData} from "../../dataSource/signIn"

const store = require("store")
const useStyles = makeStyles((theme) => signInStyle(theme))

const OidcCallback = props => {
	const classes = useStyles()
	const history = useHistory()
	const {search} = useLocation()
	
	// Get URL query Paramater
	const searchParams = new URLSearchParams(search)
	const code = searchParams.get('code')
	const state = searchParams.get('state')
	const error = searchParams.get('error')


	// Alert Define
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Build Alert 
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}


	const saveLoginInfo = async (oidcResult, userData) => {
		store.set("site", userData.data[0].site.site_seq)
		store.set("site_code", userData.data[0].site.code)
		store.set("user_seq", userData.data[0].user_seq)
		store.set("site_user_seq", userData.data[0].site_user_seq)
		store.set("locale", 10001)
		store.set("username", userData.data[0].username)
		store.set("fullname", userData.data[0].fullname)
		store.set("user_category_code", userData.data[0].company.category[0].category_code || "")
		store.set("current_module_seq", null)
		store.set("access_token", oidcResult.data.access_token)
		store.set("refresh_token", oidcResult.data.refresh_token)
		store.set("loggedIn", true)
	}


	useEffect(() => {

		if (code) {
			oidcSignIn(code, state).then(oidcResult => {
				if (oidcResult.type === "success") {
					getUserData(oidcResult.data.token_type + " " + oidcResult.data.access_token).then(userData => {
						saveLoginInfo(oidcResult, userData).then(() => {
							history.push("/dashboard")
						})
					})
				}
				else if (oidcResult.type === "error") {
					buildAlert({
						// Alert Type: success, info, warning, error
						type: "error",
						title: "Error Alert",
						content: oidcResult.message
					})
				}
			})
		}
		else if (error) {
			setTimeout(() => {
				history.push("/signin")
			}, 2000)

			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error
			})
		}

	}, [])


  return (
	// console.log("OIDC Code | Variable: code (Callback.js)"),
	// console.log(code),

	// console.log("OIDC Error | Variable: error (Callback.js)"),
	// console.log(error),

	// console.log("---------------------------------------------------------------------------------"),


	<Fragment>
		<div>
		<Alert
			open={alertOpen}
			alertType={alertData.type}
			alertTitle={alertData.title}
			alertContent={alertData.content}
			handleClose={() => setAlertOpen(false)}
		/>
		</div>

	</Fragment>
	)
}


export default OidcCallback
